<template>
  <div class="newsItem">
    <PcSolveShow class="PC" />
    <MdCaseShow class="MD" />
  </div>
</template>

<script>
// 移动端
import MdCaseShow from "./MdCaseShow.vue";
// pc端
import PcSolveShow from "./PcSolveShow.vue";
// 引入获取解决方案类型
import { customerCaseInfo } from "@/api/client";
import request from "@/utils/request";
export default {
  name: "newsMain",
  components: {
    PcSolveShow,
    MdCaseShow
  },
  data() {
    return {
      caseInfo: {}
    };
  },
  mounted() {
    // this.homeCustomer()
    // this.customerCaseType()
    // this.customerCase({ID:1})
    this.customerCaseInfo({ ID: this.$route.params.id });
  },
  methods: {
    // 客户案例详情
    async customerCaseInfo(data) {
      const res = await customerCaseInfo(data);
      // console.log(res, 'customerCaseInfocustomerCaseInfo')
      if (res.Msg === "获取成功") {
        const oldBase = "/Upload/Image/";
        this.caseInfo = res.Data;
        this.caseInfo.TitlePic =
          request.defaults.baseURL + this.caseInfo.TitlePic;
        // this.solveList.forEach(item => {
        //   item.TitlePic = request.defaults.baseURL + item.TitlePic
        //   // console.log(item.TitlePic, 'item.TitlePicitem.TitlePicitem.TitlePic')
        // })
        this.caseInfo.Content = this.caseInfo.Content.replace(
          /\/Upload\/Image\//g,
          request.defaults.baseURL + oldBase
        );
        console.log(this.caseInfo, "this.caseInfo");
        this.$store.commit("getCaseInfo", this.caseInfo);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsItem {
    .PC {
      display: none;
    }
  }
}
// PC端/
@media only screen and (min-width: 756px) {
  .newsItem {
    .MD {
      display: none;
    }
  }
}
</style>
